import React from 'react';

import { DeleteDialog } from '@/components/ui/deleteDialog/DeleteDialog.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

interface Props {
  name: string;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
}

export const FileUploadDeletionConfirmationDialog: React.FC<Props> = props => {
  const { name, onCancel, onConfirm } = props;
  const { t } = useTranslationWithPrefix('components.fileUpload.deleteDialog');

  return (
    <DeleteDialog
      cancelButtonLabel={t('cancel')}
      confirmButtonLabel={t('confirm')}
      content={t('content')}
      name={name}
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={t('title')}
    />
  );
};
